export const EMPTY_IMG =
  'https://qnm.hunliji.com/o_1dbs8fae01o74t601lq1ljquli9.png' //数据为空，小鸡
export const EMPTY_SHIP_IMG =
  'https://qnm.hunliji.com/o_1dem6mh0t2btgokvcia0j11em9.png' //数据为空，飞船
